import { Button, ButtonProps, ElementProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type ModalFormSubmitButtonProps = ButtonProps & ElementProps<'button', keyof ButtonProps>;

export const createModalFormSubmitButton = () => {
	const ModalFormSubmitButton = forwardRef<HTMLButtonElement, ModalFormSubmitButtonProps>(
		({ className, children, ...props }, ref) => (
			<Button
				ref={ref}
				data-test-id='modal-form-submit-button'
				className={clsx('modal-form-button', 'modal-form-submit', className)}
				type='submit'
				{...props}
			>
				{children}
			</Button>
		),
	);

	return ModalFormSubmitButton;
};
